import React, { useState, useRef } from 'react';

const CHIPS = [
  { key: '24h',  label: '24h',  days: 1   },
  { key: '7d',   label: '7d',   days: 7   },
  { key: '14d',  label: '14d',  days: 14  },
  { key: '1m',   label: '1m',   days: 30  },
  { key: '3m',   label: '3m',   days: 90  },
  { key: '6m',   label: '6m',   days: 180 },
  { key: 'all',  label: 'ALL',  days: 0   },
];

/**
 * Time range chip selector.
 * dataSinceDays: how many days of history we have (used to disable chips).
 */
export default function TimeRangeChips({ selected, onChange, dataSinceDays = 180 }) {
  const [tooltip, setTooltip] = useState(null);
  const timerRef = useRef(null);

  const showTip = (key, daysNeeded) => {
    clearTimeout(timerRef.current);
    const have = dataSinceDays;
    const need = daysNeeded;
    setTooltip({ key, text: `Available in ${need - have} day${need - have !== 1 ? 's' : ''}` });
  };

  const hideTip = () => {
    timerRef.current = setTimeout(() => setTooltip(null), 200);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', position: 'relative' }}>
      <span style={{ fontSize: 11, color: '#8892a5', fontWeight: 500, marginRight: 2 }}>Range:</span>
      {CHIPS.map(chip => {
        const disabled = chip.days > 0 && chip.days > dataSinceDays;
        const isActive = selected === chip.key;

        return (
          <div key={chip.key} style={{ position: 'relative' }}>
            <button
              disabled={disabled}
              onClick={() => !disabled && onChange(chip.key)}
              onMouseEnter={() => disabled && showTip(chip.key, chip.days)}
              onMouseLeave={hideTip}
              style={{
                padding: '4px 10px',
                borderRadius: 5,
                border: `1px solid ${isActive ? '#e9a020' : disabled ? '#1a2438' : '#1e2d44'}`,
                background: isActive ? 'rgba(233,160,32,0.12)' : 'transparent',
                color: isActive ? '#e9a020' : disabled ? '#3a4558' : '#8892a5',
                fontSize: 11,
                fontWeight: isActive ? 700 : 500,
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontFamily: "'JetBrains Mono', monospace",
                transition: 'all 0.12s',
              }}
            >
              {chip.label}
            </button>

            {tooltip?.key === chip.key && (
              <div style={{
                position: 'absolute',
                bottom: '130%',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#0a1628',
                border: '1px solid #1e2d44',
                borderRadius: 6,
                padding: '5px 10px',
                fontSize: 11,
                color: '#8892a5',
                whiteSpace: 'nowrap',
                zIndex: 100,
                pointerEvents: 'none',
              }}>
                {tooltip.text}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
